import React from "react";
const Footer = () =>{
    
    return (
        <>
        <footer id="footer" className="footer position-relative">
            <div className="container footer-top">
                <div className="row gy-4">
                    <div className="col-lg-4 col-md-6 footer-about">
                        <a href="index.html" className="logo d-flex align-items-center">
                            <span className="">Contact US</span>
                        </a>
                        <div className="footer-contact pt-3">
                            <p>Shaheed Benazir Bhutto Women University, LARAMA, Charsadda Road, Peshawar</p>
                            <p>New York, NY 535022</p>
                            <p className="mt-3"><strong>Phone:</strong> <span>+92-91-9224794</span></p>
                            <p><strong>Email:</strong> <span>oric@sbbwu.edu.pk</span></p>
                        </div>
                     
                    </div>
                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>Useful Links</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/MOUs">MOUs</a></li>
                            <li><a href="/Projectawarded">Project Awarded</a></li>
                            <li><a href="/Conferences">Conferences</a></li>
                            <li><a href="/Downloads">Downloads</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-2 col-md-3 footer-links">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="http://www.digitallibrary.edu.pk/">Digital Library</a></li>
                            <li><a href="http://sbbwu.edu.pk/sbbwu/Alumni_office">Alumni</a></li>
                            <li><a href="http://journal.sbbwu.edu.pk/">Journal</a></li>
                            <li><a href="http://sbbwu.edu.pk/sbbwu/Contact">Contact</a></li>
                          
                        </ul>
                    </div>
                    <div className="col-lg-2 col-md-3 footer-links">
                    <div className="social-links d-flex mt-4">
                            <a href="#"><i className="bi bi-twitter"></i></a>
                            <a href="https://www.facebook.com/profile.php?id=100064362114767"><i className="bi bi-facebook"></i></a>
                            <a href="#"><i className="bi bi-instagram"></i></a>
                            <a href="#"><i className="bi bi-linkedin"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container copyright text-center mt-4">
                <p>© <span>Copyright</span> <strong className="px-1">SiteName</strong> <span>All Rights Reserved</span></p>
                <div className="credits">
                  
                </div>
            </div>
        </footer>
        </>
    );
};
export default Footer